import { pick, flatten } from 'lodash'
import { FETCH_SITE_CONFIG_SUCCESS } from '../siteConfig/types'
import { NICHES } from 'common/constants'
import descriptions from 'components/Modal/FlagSetter/flags'

const keys = flatten(Object.values(descriptions).map(e => Object.keys(e)))

const initialState = pick(sessionStorage, keys)

const flags = (state = initialState, { type, data, payload }) => {
  if (type == FETCH_SITE_CONFIG_SUCCESS) {
    const { nicheId = NICHES.ADULT_REACT, features } = payload
    return {
      disableCCP: !features.ccp,
      mailbox: ![NICHES.ADULT_REACT, NICHES.ADULT_RELOAD].includes(nicheId),
      adult: [NICHES.ADULT_REACT, NICHES.ADULT, NICHES.ADULT_RELOAD].includes(nicheId),
      photofilter: [NICHES.ADULT_REACT, NICHES.ADULT].includes(nicheId),
      vip: nicheId != NICHES.ADULT_REACT,
      ...initialState,
    }
  }
  if (type == 'SET_FLAG') {
    const { key, value } = data
    sessionStorage[key] = value
    return { ...state, [key]: value }
  }
  return state
}

export default flags
